export var DefaultSnapshotSchedulesState;
(function (DefaultSnapshotSchedulesState) {
    DefaultSnapshotSchedulesState[DefaultSnapshotSchedulesState["UNKNOWN"] = 0] = "UNKNOWN";
    DefaultSnapshotSchedulesState[DefaultSnapshotSchedulesState["LEGACY_FILESPACE_INITIALIZATION"] = 1] = "LEGACY_FILESPACE_INITIALIZATION";
    DefaultSnapshotSchedulesState[DefaultSnapshotSchedulesState["CREATE_IMMEDIATELY"] = 2] = "CREATE_IMMEDIATELY";
    DefaultSnapshotSchedulesState[DefaultSnapshotSchedulesState["SCHEDULES_INITIALIZED"] = 3] = "SCHEDULES_INITIALIZED";
})(DefaultSnapshotSchedulesState || (DefaultSnapshotSchedulesState = {}));
